import { z } from "zod";

// payOS Webhook Data Schema
export const PayOSWebhookDataSchema = z.object({
  orderCode: z.number(),
  amount: z.number(),
  description: z.string(),
  accountNumber: z.string(),
  reference: z.string(),
  transactionDateTime: z.string(),
  currency: z.string(),
  paymentLinkId: z.string(),
  code: z.string(),
  desc: z.string(),
  counterAccountBankId: z.string().nullable().optional(),
  counterAccountBankName: z.string().nullable().optional(),
  counterAccountName: z.string().nullable().optional(),
  counterAccountNumber: z.string().nullable().optional(),
  virtualAccountName: z.string().nullable().optional(),
  virtualAccountNumber: z.string().nullable().optional(),
});
export type PayOSWebhookData = z.infer<typeof PayOSWebhookDataSchema>;

// payOS Webhook Request Schema
export const PayOSWebhookRequestSchema = z.object({
  code: z.string(),
  desc: z.string(),
  success: z.boolean(),
  data: PayOSWebhookDataSchema,
  signature: z.string(),
});
export type PayOSWebhookRequest = z.infer<typeof PayOSWebhookRequestSchema>;

// Webhook verification result
export interface WebhookVerificationResult {
  isValid: boolean;
  error?: string;
  data?: PayOSWebhookData;
}
